// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"2e37eb88","453":"759f26a2","682":"df549f43","784":"e2d4566d","805":"14702a89","923":"40909ec9","980":"2f9b859f"}[chunkId] + ".chunk.js";
};